<h2 mat-dialog-title>Reset Password</h2>

<mat-dialog-content>
  @if (!success) {
    <p>Send a password reset link to this email address?</p>
    <p class="email-display">{{ data.email }}</p>
    
    @if (error) {
      <div class="error-message">
        {{ error }}
      </div>
    }
  }
  
  @if (success) {
    <div class="success-container">
      <p>{{ successMessage }}</p>
      <p>Please check your inbox and follow the instructions to reset your password.</p>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  @if (!success) {
    <button mat-button (click)="onCancel()" [disabled]="loading">Cancel</button>
  }
  @if (!success) {
    <button mat-raised-button color="primary" (click)="onConfirm()" [disabled]="loading">
      @if (loading) {
        <mat-spinner diameter="20" class="spinner"></mat-spinner>
      } @else {
        <span>Send Reset Link</span>
      }
    </button>
  }
  @if (success) {
    <button mat-button (click)="dialogRef.close()">Close</button>
  }
</mat-dialog-actions>
